import React from "react";
import styled from "styled-components";
import { useModal } from "@carvana/helios-layout";
import { useFlags } from "launchdarkly-react-client-sdk";
import {
  background,
  border,
  text,
  heading,
  spacing,
  body,
} from "@carvana/helios-styles";

type AuctionBuyFeeSchedule =
  | {
      fee: string;
      range: string;
    }[]
  | undefined;

export default function useBuyFeeModal() {
  const { Modal, ...rest } = useModal();

  const BuyFeeModal = () => {
    const { auctionBuyFeeSchedule = [] } = useFlags<{
      auctionBuyFeeSchedule: AuctionBuyFeeSchedule;
    }>();

    return (
      <Modal modalHeader="Buy Fee Schedule" desktopWidth="552px">
        <ModalContent>
          {auctionBuyFeeSchedule.length > 0 ? (
            <BuyFeeScheduleTable>
              <BuyFeeScheduleTableHead>
                <BuyFeeScheduleTableRow>
                  <BuyFeeScheduleTableHeader>
                    Purchase amount
                  </BuyFeeScheduleTableHeader>
                  <BuyFeeScheduleTableHeader>
                    Buyer fee
                  </BuyFeeScheduleTableHeader>
                </BuyFeeScheduleTableRow>
              </BuyFeeScheduleTableHead>
              <tbody>
                {auctionBuyFeeSchedule.map((schedule) => (
                  <BuyFeeScheduleTableRow key={schedule.range}>
                    <BuyFeeScheduleTableCell>
                      {schedule.range}
                    </BuyFeeScheduleTableCell>
                    <BuyFeeScheduleTableCell>
                      {schedule.fee}
                    </BuyFeeScheduleTableCell>
                  </BuyFeeScheduleTableRow>
                ))}
              </tbody>
            </BuyFeeScheduleTable>
          ) : (
            <Text>Oops, something went wrong.</Text>
          )}
        </ModalContent>
      </Modal>
    );
  };

  return {
    BuyFeeModal,
    ...rest,
  };
}

const ModalContent = styled.div`
  width: 100%;
  margin-top: -16px;
`;

const BuyFeeScheduleTable = styled.table`
  width: 100%;
  height: calc(100vh - (var(--header-height) + var(--banner-height)));
`;

const BuyFeeScheduleTableHead = styled.thead`
  background: ${background.weak};
`;

const BuyFeeScheduleTableRow = styled.tr`
  border-bottom: 1px solid ${border.subtle};
`;

const BuyFeeScheduleTableHeader = styled.th`
  ${heading.xs};
  color: ${text.strong};
  padding: ${spacing.lg} ${spacing.xl};
`;

const BuyFeeScheduleTableCell = styled.td`
  ${body.regular.sm};
  color: ${text.default};
  padding: ${spacing.lg} ${spacing.xl};
`;

const Text = styled.p`
  ${body.regular.md};
  color: ${text.default};
`;
